export const events = [
  {
    id: 'tributo_shakira',
    title: 'Tributo a Shakira',
    date: '2026-06-14',
    dateFormatted: 'Sábado 14 de Junio',
    time: '8:00 PM',
    description: 'Legatto nos trae el mejor tributo a la reina del pop latino. Todos sus éxitos en vivo con la energía de La Capital.',
    category: 'music',
    image: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?q=80&w=800&auto=format&fit=crop',
    featured: true,
    ctaText: 'Reservar Mesa',
    ctaUrl: '#reservar'
  },
  {
    id: 'tributo_arjona',
    title: 'Tributo a Ricardo Arjona',
    date: '2026-06-21',
    dateFormatted: 'Sábado 21 de Junio',
    time: '8:00 PM',
    description: 'Latido presenta un homenaje al cantautor más grande de Centroamérica. Una noche para recordar.',
    category: 'music',
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?q=80&w=800&auto=format&fit=crop',
    featured: false,
    ctaText: 'Reservar Mesa',
    ctaUrl: '#reservar'
  },
  {
    id: 'tributo_elvis',
    title: 'Tributo a Elvis Presley',
    date: '2026-06-28',
    dateFormatted: 'Sábado 28 de Junio',
    time: '8:00 PM',
    description: 'El rock and roll vive en La Capital. El mejor tributo al rey con promoción 3x2 en hamburguesas clásicas.',
    category: 'music',
    image: 'https://images.unsplash.com/photo-1498038432885-c6f3f1b912ee?q=80&w=800&auto=format&fit=crop',
    featured: false,
    ctaText: 'Reservar Mesa',
    ctaUrl: '#reservar'
  },
  {
    id: 'edward_maya',
    title: 'Edward Maya en Nicaragua',
    date: '2026-11-22',
    dateFormatted: 'Sábado 22 de Noviembre',
    time: '9:00 PM',
    description: 'El artista internacional llega a La Capital de la mano de Masshow Productions. Una noche épica que no te puedes perder.',
    category: 'music',
    image: 'https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?q=80&w=800&auto=format&fit=crop',
    featured: true,
    ctaText: 'Comprar Entradas',
    ctaUrl: '#reservar'
  },
  {
    id: 'mundial_2026',
    title: 'Viví el Mundial en La Capital',
    date: '2026-06-11',
    dateFormatted: 'Junio - Julio 2026',
    time: 'Según calendario FIFA',
    description: 'Pantallas gigantes, sonido envolvente, hamburguesas, cervezas heladas y la mejor vibra deportiva. ¡El Mundial se vive en La Capital!',
    category: 'sports',
    image: 'https://images.unsplash.com/photo-1540747737956-3787293ac287?q=80&w=800&auto=format&fit=crop',
    featured: true,
    ctaText: 'Ver Calendario',
    ctaUrl: '#live'
  },
  {
    id: 'grill_moto_fest',
    title: 'Grill Moto Fest',
    date: '2026-07-26',
    dateFormatted: 'Sábado 26 de Julio',
    time: '4:00 PM',
    description: 'La combinación perfecta: motos, parrilla, cerveza fría y rock en vivo. Un evento único en Plaza La Fe.',
    category: 'special',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85f82e?q=80&w=800&auto=format&fit=crop',
    featured: false,
    ctaText: 'Más Info',
    ctaUrl: '#reservar'
  },
  {
    id: 'musica_viva_viernes',
    title: 'Viernes de Música en Vivo',
    date: 'recurring',
    dateFormatted: 'Todos los viernes',
    time: '8:00 PM',
    description: 'Bandas locales y covers de rock, pop y más. El mejor plan para arrancar el fin de semana.',
    category: 'music',
    image: 'https://images.unsplash.com/photo-1501612780327-45045538702b?q=80&w=800&auto=format&fit=crop',
    featured: false,
    ctaText: 'Reservar',
    ctaUrl: '#reservar'
  },
  {
    id: 'sabado_dj',
    title: 'Sábado Night con DJ',
    date: 'recurring',
    dateFormatted: 'Todos los sábados',
    time: '9:00 PM',
    description: 'La mejor selección musical con DJ en vivo para cerrar la semana con broche de oro.',
    category: 'music',
    image: 'https://images.unsplash.com/photo-1571266028243-d220c6d5f7eb?q=80&w=800&auto=format&fit=crop',
    featured: false,
    ctaText: 'Reservar',
    ctaUrl: '#reservar'
  }
]

export const eventCategories = [
  { id: 'all', name: 'Todos', icon: '🔥' },
  { id: 'sports', name: 'Deportes', icon: '⚽' },
  { id: 'music', name: 'Música en Vivo', icon: '🎸' },
  { id: 'special', name: 'Eventos Especiales', icon: '⭐' }
]

export function getFeaturedEvents() {
  return events.filter(e => e.featured)
}

export function getEventsByCategory(categoryId) {
  if (categoryId === 'all') return events
  return events.filter(e => e.category === categoryId)
}
